/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

export enum ReportConsolidationAction {
  Merge = 0,
  Zip = 1,
}
